"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = sequence;
function sequence(action) {
    var sequenceValues = [];
    var steps = [];
    var currentStep = -1;

    var isItemStep = function isItemStep(stepName) {
        return function (_ref) {
            var itemStepName = _ref.step;
            return itemStepName === stepName;
        };
    };

    var executeStep = function executeStep(stepName) {
        sequenceValues.filter(isItemStep(stepName)).forEach(action);
    };

    var next = function next() {
        if (currentStep < steps.length - 1) {
            currentStep += 1;
            var stepName = steps[currentStep];
            executeStep(stepName);
        } else if (steps.length > 1) {
            currentStep = -1;
            next();
        }
    };

    return {
        next: next,
        play: function play(interval) {
            next();
            var intervalId = setInterval(next, interval);
            return {
                abort: function abort() {
                    clearInterval(intervalId);
                }
            };
        },
        reset: function reset() {
            currentStep = -1;
        },
        addValues: function addValues(items) {
            sequenceValues = sequenceValues.concat(items);
            steps = sequenceValues.map(function (_ref2) {
                var step = _ref2.step;
                return step;
            }).filter(function (item, index, array) {
                return array.indexOf(item) === index;
            });
        },

        getSteps: function getSteps() {
            return steps;
        },
        getCurrentStep: function getCurrentStep() {
            if (currentStep >= 0) {
                return steps[currentStep];
            }
            return null;
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/utils/sequence.js
// module id = 1834
// module chunks = 1